(function () {
  function initDrums(cover, media) {
    var wrap = document.createElement('div');
    wrap.className = 'pad-grid';
    for (var i = 0; i < 16; i++) {
      var pad = document.createElement('div');
      pad.className = 'drum-pad';
      wrap.appendChild(pad);
    }
    cover.appendChild(wrap);
    var pads = Array.prototype.slice.call(wrap.children);
    var timers = [];
    var active = false;

    function clear() {
      timers.forEach(function (t) { clearTimeout(t); });
      timers = [];
      pads.forEach(function (p) { p.classList.remove('lit'); });
    }

    function run() {
      if (!active) return;
      var noteValues = [60, 90, 120, 180, 240, 360, 480];
      var t = 0;
      var hits = 5 + Math.floor(Math.random() * 5);
      for (var i = 0; i < hits; i++) {
        var gap = noteValues[Math.floor(Math.random() * noteValues.length)];
        t += gap;
        (function (delay) {
          var pad = pads[Math.floor(Math.random() * pads.length)];
          timers.push(setTimeout(function () {
            pad.classList.add('lit');
            setTimeout(function () { pad.classList.remove('lit'); }, 110);
          }, delay));
        })(t);
      }
      timers.push(setTimeout(run, t + 220));
    }

    media.addEventListener('mouseenter', function () { active = true; run(); });
    media.addEventListener('mouseleave', function () { active = false; clear(); });
  }

  function initPresets(cover, media) {
    var wrap = document.createElement('div');
    wrap.className = 'preset-wrap';
    wrap.innerHTML =
      '<svg width="100%" height="100%" style="position:absolute;inset:0;overflow:visible;" viewBox="0 0 100 100" preserveAspectRatio="none">' +
      '<path class="cable cable-a" d="M-6,22 C18,4 28,38 50,20 C68,5 82,28 108,12" />' +
      '<path class="cable cable-b" d="M-6,78 C20,96 34,62 55,80 C74,98 88,74 108,90" />' +
      '<path class="cable cable-c" d="M14,-6 C26,26 12,52 40,58 C58,62 52,88 68,108" />' +
      '<path class="cable cable-d" d="M92,-6 C78,22 92,44 64,50 C44,54 52,82 28,108" />' +
      '<path class="cable cable-e" d="M-6,50 C16,44 20,64 44,66 C64,68 66,40 92,46" />' +
      '<circle class="cable-tip" cx="-6" cy="22" r="3" />' +
      '<circle class="cable-tip" cx="108" cy="12" r="3" />' +
      '<circle class="cable-tip" cx="-6" cy="78" r="3" />' +
      '<circle class="cable-tip" cx="108" cy="90" r="3" />' +
      '<circle class="cable-tip" cx="14" cy="-6" r="3" />' +
      '<circle class="cable-tip" cx="68" cy="108" r="3" />' +
      '<circle class="cable-tip" cx="92" cy="-6" r="3" />' +
      '<circle class="cable-tip" cx="28" cy="108" r="3" />' +
      '<circle class="cable-tip" cx="-6" cy="50" r="3" />' +
      '<circle class="cable-tip" cx="92" cy="46" r="3" />' +
      '</svg>';
    var knobDefs = [
      { top: 45, left: 26, dur: 3.1 },
      { top: 45, left: 50, dur: 3.8 },
      { top: 52, left: 76, dur: 2.8 }
    ];
    knobDefs.forEach(function (k) {
      var knob = document.createElement('div');
      knob.className = 'knob';
      knob.style.top = k.top + '%';
      knob.style.left = k.left + '%';
      var ring = document.createElement('div');
      ring.className = 'knob-ring';
      var face = document.createElement('div');
      face.className = 'knob-face';
      var rotor = document.createElement('div');
      rotor.className = 'knob-rotor';
      rotor.style.animationDuration = k.dur + 's';
      var dot = document.createElement('div');
      dot.className = 'knob-dot';
      rotor.appendChild(dot);
      knob.appendChild(ring);
      knob.appendChild(face);
      knob.appendChild(rotor);
      wrap.appendChild(knob);
    });
    cover.appendChild(wrap);
  }

  function initMelody(cover, media) {
    var wrap = document.createElement('div');
    wrap.className = 'melody-wrap';
    wrap.innerHTML =
      '<svg viewBox="0 0 160 60" width="100%" height="100%" style="position:absolute;inset:0;">' +
      '<path class="contour-path" d="M0,42 C20,12 40,50 60,24 C80,2 100,44 120,18 C135,2 150,28 160,12"/>' +
      '</svg><div class="note-marks"></div>';
    cover.appendChild(wrap);

    var notePositions = [
      [8, 40], [22, 16], [38, 46], [52, 26], [66, 6], [80, 40],
      [96, 20], [110, 46], [124, 10], [138, 30], [152, 14]
    ];
    var marksEl = wrap.querySelector('.note-marks');
    var marks = [];
    notePositions.forEach(function (pos) {
      var m = document.createElement('div');
      m.className = 'note-mark';
      m.style.left = pos[0] + '%';
      m.style.top = pos[1] + '%';
      marksEl.appendChild(m);
      marks.push(m);
    });

    var timers = [];
    media.addEventListener('mouseenter', function () {
      cover.classList.remove('was-drawn');
      var order = marks.slice().sort(function () { return Math.random() - 0.5; });
      var t = 0;
      order.forEach(function (mark) {
        t += 50 + Math.random() * 170;
        var widthPx = 8 + Math.random() * 26;
        var holdMs = widthPx * 35;
        mark.style.width = widthPx + 'px';
        (function (onDelay, hold, el) {
          timers.push(setTimeout(function () {
            el.classList.add('on');
            timers.push(setTimeout(function () { el.classList.remove('on'); }, hold));
          }, onDelay));
        })(t, holdMs, mark);
      });
    });
    media.addEventListener('mouseleave', function () {
      timers.forEach(function (tm) { clearTimeout(tm); });
      timers = [];
      marks.forEach(function (m) { m.classList.remove('on'); });
      cover.classList.add('was-drawn');
    });
  }

  function initTextures(cover, media) {
    var wrap = document.createElement('div');
    wrap.className = 'sparkle-field';
    cover.appendChild(wrap);
    var count = 22;
    var sparkles = [];
    for (var s = 0; s < count; s++) {
      var el = document.createElement('div');
      el.className = 'sparkle';
      var xPct = Math.random() * 92;
      el.style.left = xPct + '%';
      el.style.top = (Math.random() * 92) + '%';
      el.dataset.x = xPct;
      wrap.appendChild(el);
      sparkles.push(el);
    }
    var timers = [];
    var active = false;
    var focusX = 0;
    var focusDir = 1;
    var focusTimer = null;

    function pickWeighted() {
      if (Math.random() < 0.35) {
        return sparkles[Math.floor(Math.random() * sparkles.length)];
      }
      var sorted = sparkles.slice().sort(function (a, b) {
        return Math.abs(parseFloat(a.dataset.x) - focusX) - Math.abs(parseFloat(b.dataset.x) - focusX);
      });
      var pool = sorted.slice(0, 6);
      return pool[Math.floor(Math.random() * pool.length)];
    }

    function schedule() {
      if (!active) return;
      var el = pickWeighted();
      el.classList.add('on');
      var hold = 200 + Math.random() * 500;
      timers.push(setTimeout(function () { el.classList.remove('on'); }, hold));
      timers.push(setTimeout(schedule, 90 + Math.random() * 220));
    }

    function drift() {
      if (!active) return;
      focusX += focusDir * 0.6;
      if (focusX > 92) { focusX = 92; focusDir = -1; }
      if (focusX < 0) { focusX = 0; focusDir = 1; }
      focusTimer = setTimeout(drift, 60);
    }

    media.addEventListener('mouseenter', function () {
      active = true;
      schedule();
      schedule();
      drift();
    });
    media.addEventListener('mouseleave', function () {
      active = false;
      timers.forEach(function (t) { clearTimeout(t); });
      timers = [];
      clearTimeout(focusTimer);
      sparkles.forEach(function (s) { s.classList.remove('on'); });
    });
  }

  function init() {
    var covers = document.querySelectorAll('.pf-cover[data-fx]');
    covers.forEach(function (cover) {
      var media = cover.closest('.card__media') || cover.parentElement;
      if (!media) return;
      switch (cover.getAttribute('data-fx')) {
        case 'drums': initDrums(cover, media); break;
        case 'presets': initPresets(cover, media); break;
        case 'melody': initMelody(cover, media); break;
        case 'textures': initTextures(cover, media); break;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
